export const JSON_CONTENT = {
  NFT_DATA: '/nft_data.json',
  META_DATA: '/meta_data.json',
  CONTENT: '/content.json'
};
